<h4 class="text-xl font-semibold mt-3 ml-3">
  {{ title | translate | interpolate: params }}
</h4>

@if (subtitle) {
<p class="mb-1 mt-1 ml-3 mr-3 border-box color-light">
  {{ subtitle | translate | interpolate: params }}
</p>
}

<soft-tab-group
  [activatedIndex]="strategy.activatedView()"
  (activatedIndexChange)="strategy.activatedView.set($event)"
  [hideSelection]="config.views.length <= 1"
>
  @for (view of config.views; track trackByView($index, view)) {
  <soft-tab [title]="view.title">
    <div class="max-h-[80vh] overflow-y-auto">
      <ng-container
        *ngComponentOutlet="view.component; inputs: { config: view.config }"
      ></ng-container>
    </div>
  </soft-tab>
  }
</soft-tab-group>
